// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/analytics';
import model_2 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/apiKeys';
import model_3 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/automation';
import model_4 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/billing';
import model_5 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/bookingPages';
import model_6 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/call';
import model_7 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/contact';
import model_8 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/customer';
import model_9 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/date';
import model_10 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/emailCenter';
import model_11 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/extraFields';
import model_12 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/help';
import model_13 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/image';
import model_14 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/journey';
import model_15 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/lead';
import model_16 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/leadsAnalytics';
import model_17 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/leadSource';
import model_18 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/leadState';
import model_19 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/leadTask';
import model_20 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/location';
import model_21 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/periodSelector';
import model_22 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/preferences';
import model_23 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/productGroup';
import model_24 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/promotion';
import model_25 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/role';
import model_26 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/salesInfluencer';
import model_27 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/serviceRequest';
import model_28 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/skill';
import model_29 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/tagStatistics';
import model_30 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/taskAutomation';
import model_31 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/ticketDrawer';
import model_32 from '/opt/atlassian/pipelines/agent/build/packages/apps/backoffice/src/models/user';

export const models = {
model_1: { namespace: 'analytics', model: model_1 },
model_2: { namespace: 'apiKeys', model: model_2 },
model_3: { namespace: 'automation', model: model_3 },
model_4: { namespace: 'billing', model: model_4 },
model_5: { namespace: 'bookingPages', model: model_5 },
model_6: { namespace: 'call', model: model_6 },
model_7: { namespace: 'contact', model: model_7 },
model_8: { namespace: 'customer', model: model_8 },
model_9: { namespace: 'date', model: model_9 },
model_10: { namespace: 'emailCenter', model: model_10 },
model_11: { namespace: 'extraFields', model: model_11 },
model_12: { namespace: 'help', model: model_12 },
model_13: { namespace: 'image', model: model_13 },
model_14: { namespace: 'journey', model: model_14 },
model_15: { namespace: 'lead', model: model_15 },
model_16: { namespace: 'leadsAnalytics', model: model_16 },
model_17: { namespace: 'leadSource', model: model_17 },
model_18: { namespace: 'leadState', model: model_18 },
model_19: { namespace: 'leadTask', model: model_19 },
model_20: { namespace: 'location', model: model_20 },
model_21: { namespace: 'periodSelector', model: model_21 },
model_22: { namespace: 'preferences', model: model_22 },
model_23: { namespace: 'productGroup', model: model_23 },
model_24: { namespace: 'promotion', model: model_24 },
model_25: { namespace: 'role', model: model_25 },
model_26: { namespace: 'salesInfluencer', model: model_26 },
model_27: { namespace: 'serviceRequest', model: model_27 },
model_28: { namespace: 'skill', model: model_28 },
model_29: { namespace: 'tagStatistics', model: model_29 },
model_30: { namespace: 'taskAutomation', model: model_30 },
model_31: { namespace: 'ticketDrawer', model: model_31 },
model_32: { namespace: 'user', model: model_32 },
} as const
